const config = {
    projectId: "mission-top-5",
    communityName: "Mission TOP 5",
    productionUrl: "https://mt5.dreico.net",
    algoliaIndex: "mission_top_5_user",
}

export default config